(() => {
 const cache = new Map();
 const queue = [];
 let active = 0;
 const root = window.Shopify?.routes?.root || '/';
 const pump = () => {
  while (active < 3 && queue.length) {
   const {url, resolve, reject} = queue.shift(); active++;
   fetch(url, {headers: {Accept: 'application/json'}, signal: AbortSignal.timeout(10000)})
    .then(r => { if (!r.ok) throw new Error('Unavailable'); return r.json(); })
    .then(resolve, reject).finally(() => { active--; pump(); });
  }
 };
 const product = url => {
  if (!cache.has(url)) cache.set(url, new Promise((resolve, reject) => { queue.push({url, resolve, reject}); pump(); }));
  return cache.get(url);
 };
 const init = (scope = document) => scope.querySelectorAll('[data-plush-catalog]').forEach(catalog => {
  if (catalog.dataset.quickReady) return; catalog.dataset.quickReady = 'true';
  const prepare = async card => {
   if (card.dataset.quickLoaded) return; card.dataset.quickLoaded = 'true';
   const link = card.querySelector('a[href*="/products/"]');
   if (!link || card.querySelector('.original-retired')) return;
   try {
    const url = new URL(link.href); url.search = ''; url.hash = ''; url.pathname += '.js';
    const data = await product(url.href);
    const variants = data.variants.filter(v => v.available);
    if (!data.available || !variants.length) {
     const label = document.createElement('span'); label.className = 'catalog-stock-note'; label.textContent = catalog.dataset.soldLabel; card.append(label); return;
    }
    const form = document.createElement('form'); form.method = 'post'; form.action = root + 'cart/add'; form.dataset.productForm = ''; form.className = 'catalog-quick-add';
    const field = document.createElement(variants.length > 1 ? 'select' : 'input'); field.name = 'id';
    if (variants.length > 1) {
     field.setAttribute('aria-label', catalog.dataset.optionLabel + ': ' + data.title);
     variants.forEach(v => { const option = document.createElement('option'); option.value = v.id; option.textContent = v.title; field.append(option); });
    } else { field.type = 'hidden'; field.value = variants[0].id; }
    const button = document.createElement('button'); button.type = 'submit'; button.className = 'button'; button.textContent = catalog.dataset.addLabel; button.setAttribute('aria-label', catalog.dataset.addLabel + ': ' + data.title);
    const error = document.createElement('p'); error.className = 'form-error'; error.hidden = true; error.setAttribute('role','alert');
    form.append(field, button, error); card.append(form);
   } catch (_) { card.dataset.quickLoaded = ''; }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { prepare(entry.target); observer.unobserve(entry.target); } }), {rootMargin: '100px'}) : null;
  catalog.querySelectorAll('.original-character-grid article').forEach(card => {
   if (!card.querySelector('a[href*="/products/"]') || card.querySelector('.original-retired')) return;
   observer?.observe(card);
   card.addEventListener('pointerenter', () => prepare(card)); card.addEventListener('focusin', () => prepare(card));
  });
 });
 init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
